import { render, staticRenderFns } from "./CouponEcho.vue?vue&type=template&id=5fdf5b8a&scoped=true"
import script from "./CouponEcho.vue?vue&type=script&lang=js"
export * from "./CouponEcho.vue?vue&type=script&lang=js"
import style0 from "./CouponEcho.vue?vue&type=style&index=0&id=5fdf5b8a&prod&lang=less&scoped=true"
import style1 from "./CouponEcho.vue?vue&type=style&index=1&id=5fdf5b8a&prod&lang=scss"
import style2 from "./CouponEcho.vue?vue&type=style&index=2&id=5fdf5b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf5b8a",
  null
  
)

export default component.exports